import { ContactForm } from '~/components/contact/ContactForm';

export default function EditContactRoute() {
  return <ContactForm title='Edit Contact' />;
}
